module.exports = __webpack_public_path__ + "static/media/edit_student_schedule_add_remove_section.494dd4d3.mov";